import React from 'react';
import './DynamicLinkRow.component.css';

export default class DynamicLinkRow extends React.Component {

    constructor(props) {
        super(props);

        this.toggleAppointmentConfirm = this.toggleAppointmentConfirm.bind(this);

        this.setSelectedAppointmentSuggestionIndex = this.setSelectedAppointmentSuggestionIndex.bind(this);
        this.setAppointmentReferenceNumber = this.setAppointmentReferenceNumber.bind(this);
        this.setPreloadedEquipmentDecalId = this.setPreloadedEquipmentDecalId.bind(this);
    }

    toggleAppointmentConfirm(event) {
        this.props.onOrderChange({
            confirmed: !this.props.order.confirmed
        });
    }

    setSelectedAppointmentSuggestionIndex(event) {
        this.props.onOrderChange({
            selectedAppointmentSuggestionIndex: event.target.value
        });
    }

    setAppointmentReferenceNumber(event) {
        this.props.onOrderChange({
            appointmentReferenceNumber: event.target.value
        });
    }

    setPreloadedEquipmentDecalId(event) {
        const preloadedEquipmentDecalId = event.target.value.replace(/\s+/g, '');
        const requiredDecalPattern = /^(([a-zA-Z]{2}){1,2}\d{6})?$/;
        const preloadEquipmentError = !requiredDecalPattern.test(preloadedEquipmentDecalId);

        this.props.onOrderChange({
            preloadEquipmentError,
            preloadedEquipmentDecalId
        });
    }

    renderColumn(header) {
        if (header.isSpecialColumn) {
            return this.renderSpecialColumn(header);
        }

        if (header.isReferenceColumn) {
            return <td> {this.props.order.reference[header.displayName]} </td>
        }

        if (header.isAdditionalWorklistColumn) {
            if (this.props.order.additionalWorklist[header.objectKey] === true) {
                return <td> {"Y"} </td>
            } else if (this.props.order.additionalWorklist[header.objectKey] === false) {
                return <td> {"N"} </td>
            } else {
                return <td> {this.props.order.additionalWorklist[header.objectKey]} </td>
            }
        }

        if (header.isValueColumn) {
            return <td>{this.props.order[header.objectKey]}</td>
        }

        return <td></td>
    }

    renderSpecialColumn(header) {
        switch (header.displayName) {
            case 'Confirm': return this.renderConfirmColumn();
            case 'References': return this.renderReferencesColumn();
            case 'Appt Start - End': return this.renderAppointmentSuggestionSelection();
            case 'Appt Reference Number': return this.renderAppointmentReferenceNumber();
            case 'Preloaded Equipment Decal ID': return this.renderPreloadedEquipmentDecal();
            default: return (<td></td>);
        }
    }

    renderConfirmColumn() {
        return (
            <td>
                <input type="checkbox"
                    checked={this.props.order.confirmed}
                    onChange={this.toggleAppointmentConfirm}
                    disabled={this.props.isSubmitting} />
            </td>
        );
    }

    renderReferencesColumn() {
        return (
            <td>
                <ul>
                    {this.props.order.references.map(r => <li>{r}</li>)}
                </ul>
            </td>
        );
    }

    renderAppointmentSuggestionSelection() {
        return (
            <td>
                <select
                    value={this.props.order.selectedAppointmentSuggestionIndex}
                    onChange={this.setSelectedAppointmentSuggestionIndex}
                    disabled={this.props.isSubmitting} >
                    {
                        this.props.order.appointmentSuggestionsList.map((appointment, index) => {
                            return <option value={index}>{appointment.suggestionDisplayString}</option>
                        })
                    }
                </select>
            </td>
        );
    }

    renderAppointmentReferenceNumber() {
        if (this.props.order.showAppointmentReferenceNumber) {
            return (
                <td>
                    <input
                        type="text"
                        placeholder="Enter reference number (if required)"
                        value={this.props.order.appointmentReferenceNumber}
                        onChange={this.setAppointmentReferenceNumber}
                        disabled={this.props.isSubmitting} />
                </td>
            );
        }
    }

    renderPreloadedEquipmentDecal() {
        if (this.props.order.showPreloadedEquipmentDecal) {
            return (
                <td>
                    <input
                        type="text"
                        className={(this.props.order.preloadEquipmentError ? 'invalid-input' : '')}
                        placeholder="e.g. TA123456 or SNLU123456 (if available)"
                        value={this.props.order.preloadedEquipmentDecalId}
                        maxLength="10"
                        onChange={this.setPreloadedEquipmentDecalId}
                        disabled={this.props.isSubmitting} />
                </td>
            );
        }
    }

    render() {
        return (
            <tr>
                {this.props.headers.map(h => this.renderColumn(h))}
            </tr>
        );
    }
}
